// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__3RF6l","Indicador":"mexico_Indicador__3Jlq2","FadeIn":"mexico_FadeIn__8ncub","fadeIn":"mexico_fadeIn__1Z9ld"};